<template>
  <el-tree
    :data="nodeList"
    :show-checkbox="false"
    node-key="id"
    :expand-on-click-node="false"
    :default-expanded-keys="focusNodes"
    icon-class="icon-CaretDown"
    v-bind="$attrs"
    v-on="$listeners"
    @node-click="nodeClick"
    :filter-node-method="filterNode"
    ref="tree"
  />
</template>

<script>
export default {
  props: {
    reg: {
      type: String,
      default: "",
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    selectCtlogAliasNm: {
      type: String,
      default: "",
    },
    nodeList: {
      type: Array,
      default: () => []
    },
    filterText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      oldClickNode: null,
      oldFocusNode: null,
      targetNode: null,
      targetParentNode: null,
      focusData: [],
      checkAll: false,
      focusNodes: ["0"],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    nodeClick(selectedNode) {
      this.$emit("nodeClick", selectedNode);

      if (this.$refs.tree.currentNode !== this.oldFocusNode) {
        if (this.oldFocusNode) {
          this.oldFocusNode.$el.style = "";
        }
        if (this.$refs.tree.currentNode.$el.style.length === 0) {
          this.$refs.tree.currentNode.$el.style = "background-color: #dfeeff";
        } else {
          this.$refs.tree.currentNode.$el.style = "";
        }
      }
      this.oldFocusNode = this.$refs.tree.currentNode;
    },
    checkAllFocusingTree() {
      const allFocus =
        this.$refs.tree.getCheckedKeys().length ==
        this.getTreeSize(this.treeList);
      if (allFocus) {
        this.$refs.tree.setCheckedKeys([]);
      } else {
        this.$refs.tree.setCheckedKeys(
          Object.keys(this.$refs.tree.store.nodesMap)
        );
      }
    },
    getTreeSize(tree) {
      let result = tree.length;
      for (let idx in tree) {
        if (tree[idx].children && tree[idx].children.length > 0) {
          result += this.getTreeSize(tree[idx].children);
        }
      }
      return result;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss">
.custom-tree-node {
  display: block;
  width: 100%;
}
.el-tree-node__expand-icon {
  transform: rotate(-90deg);
  &.expanded {
    transform: rotate(0deg);
  }
}

.context-menu {
  position: absolute;
  right: 0;
  margin-top: -20px;
  background: $--color-white;
  padding: 10px;
  border: 1px solid $--color-light-gray {
    radius: 5px;
  }
  z-index: 10;
  .el-button {
    display: flex;
    align-items: center;
    height: 30px;
    width: 100%;
    text-align: left;
    color: $--color-black;
    font: {
      size: $--font-size-base;
      weight: $--font-weight-default;
    }
    [class^="icon-"],
    [class*="icon-"] {
      margin-right: 3px;
    }
    & + .el-button {
      margin-left: 0;
    }
  }
}
</style>
